import React, { useState, useEffect, useRef } from "react";
import { categoryOptions } from "../utils/helpers";

const MultiCategorySelector = ({ selectedCategories, onCategoryChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleToggle = () => setIsOpen(!isOpen);

  const handleCheckboxChange = (categoryValue) => {
    onCategoryChange(categoryValue);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  return (
    <div className="relative" ref={dropdownRef}>
      <label className="block text-gray-700 text-sm font-bold mb-2">
        Category
      </label>
      <div
        className="shadow-sm appearance-none border rounded w-full p-2 text-gray-700 leading-tight focus:outline-none focus:ring-2 focus:ring-yellow-500 min-h-[40px] flex items-center flex-wrap gap-2 cursor-pointer"
        onClick={handleToggle}
      >
        {selectedCategories.length === 0 && (
          <span className="text-gray-400">Select Categories</span>
        )}
        {selectedCategories.map((categoryValue) => {
          const categoryLabel =
            categoryOptions.find((c) => c.value === categoryValue)?.label ||
            categoryValue;
          return (
            <span
              key={categoryValue}
              className="bg-red-100 text-red-800 text-xs font-semibold px-2.5 py-1 rounded-full flex items-center"
            >
              {categoryLabel}
              <button
                type="button"
                className="ml-2 text-red-600 hover:text-red-800"
                onClick={(e) => {
                  e.stopPropagation();
                  handleCheckboxChange(categoryValue);
                }}
              >
                &times;
              </button>
            </span>
          );
        })}
      </div>

      {isOpen && (
        <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-y-auto">
          {categoryOptions.map((option) => (
            <label
              key={option.value}
              className="flex items-center p-2 hover:bg-gray-100 cursor-pointer"
            >
              <input
                type="checkbox"
                checked={selectedCategories.includes(option.value)}
                onChange={() => handleCheckboxChange(option.value)}
                className="h-4 w-4 text-red-600 border-gray-300 rounded focus:ring-red-500"
              />
              <span className="ml-3 text-sm text-gray-700">{option.label}</span>
            </label>
          ))}
        </div>
      )}
    </div>
  );
};

export default MultiCategorySelector;
